import { UiState } from '../managers/UIManager'

interface Props { state: UiState }

export default function ErrorScreen({ state }: Props) {
  return (
    <div className="app-fullscreen error-screen-react">
      <div className="error-react-content">
        <div className="error-react-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#E91E8C" strokeWidth="1.5">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </div>

        <h2 className="error-react-title">{state.errorTitle}</h2>
        <p className="error-react-msg">{state.errorMessage}</p>

        {state.errorInstructions.length > 0 && (
          <div className="error-react-instructions">
            <h4>How to fix:</h4>
            <ol>
              {state.errorInstructions.map((step, i) => (
                <li key={i}>{step}</li>
              ))}
            </ol>
          </div>
        )}

        <button className="error-react-btn" onClick={() => window.location.reload()}>
          Refresh Page
        </button>
      </div>
    </div>
  )
}
